import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-viewonly-select-mode',
    templateUrl: './viewonly-select-mode.component.html',
    styleUrls: ['./viewonly-select-mode.component.scss'],
    standalone: false
})
export class ViewonlySelectModeComponent implements OnInit, OnChanges {
  @Input() options: any[];
  @Input() value: any;
  @Input() keyname: string;
  @Input() valuename: string;

  inputBoxValue: string = "";

  constructor() { }

  ngOnInit(): void {
    this.updateInputBoxValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateInputBoxValue();
  }

  updateInputBoxValue() {
    let self = this;
    let selected = self.options.filter(data => data[self.keyname] === self.value);
    if(selected[0]) {
      self.inputBoxValue = selected[0][self.valuename];
    }
    else {
      self.inputBoxValue = "";
    }
  }

}
